var exports = {
  "kL": "xcc377c0b--42f3b1--container",
  "Vx": "xcc377c0b--42f3b1--specifications",
  "yT": "xcc377c0b--42f3b1--specification",
  "Qq": "xcc377c0b--42f3b1--text",
  "Uq": "xcc377c0b--42f3b1--value",
};

module.exports = exports;
